import React from "react";
import { Icon } from "@chakra-ui/react";

export const HamburgerIcon = ({ ...props }) => {
  return (
    <Icon
      as="svg"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 6h18v2H3V6zm0 5h18v2H3v-2zm0 5h18v2H3v-2z"
        fill="currentColor"
      />
    </Icon>
  );
};
